/**
 * Created by chenqifeng on 2016/9/1.
 */
import {request} from '../http';
import domain from '../domain';
var OrderService = function () {
    if (domain.env === 'online') {
        this.domain = "//orderserver.51tiangou.com";
    } else {
        this.domain = "//oserv." + domain.env + ".66buy.com.cn";
    }
};
OrderService.prototype.newPreOrder = function (params = {}) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/newPreOrder", params);
};
OrderService.prototype.preOrder = function (params = {}) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/preOrder", params);
};
OrderService.prototype.validate = function (params = {}) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/validate", params);
};
OrderService.prototype.promotions = function (params = {}) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/promotions", params);
};
// 合并支付品牌商，多门店预下单优惠查询
OrderService.prototype.combinePromotions = function (params = {}) {
    var that = this;
    params.type = 'POST';
    params.contentType = params.contentType || 'application/json';
    that._serviceAjaxCom("/publics/tgouOrder/combineOrder/promotions", params);
};
OrderService.prototype.calculate = function (params) {
    var that = this;
    that._serviceAjaxCom("/publics/shippingFee/calculate", params);
};
// 合并支付品牌商，多门店合并支付运费计算
OrderService.prototype.combineCalculate = function (params) {
    var that = this;
    params.type = 'POST';
    params.contentType = params.contentType || 'application/json';
    that._serviceAjaxCom("/publics/shippingFee/combineOrder/calculate", params);
};
OrderService.prototype.validateSpeedDelivery = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/validateSpeedDelivery", params);
};
OrderService.prototype.add = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/add", params);
};
OrderService.prototype.addOrder = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/addOrder", params);
};
/**
 * 添加到购物车
 * @param params
 */
OrderService.prototype.addShopCart = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/add", params);
};
/**
 * 添加到购物车
 * @param params
 */
OrderService.prototype.cartServeOrder = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/cartServeOrder", params);
};
OrderService.prototype.shopCartLimitQty = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/shopCartLimitQty", params);
};
/**
 * 订单详情
 * @param params
 */
OrderService.prototype.payDetail = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/payOrderInfo", params);
};
/**
 * 订单详情
 * @param params
 */
OrderService.prototype.payVipDetail = function (params) {
  var that = this;
  params.type = 'POST';
  that._serviceAjaxCom("/publics/tgouOrder/vipOrder/payOrderInfo", params);
};
/**
 * 支付订单
 * @param params
 */
OrderService.prototype.pay = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/pay", params);
};
OrderService.prototype.getUsableCouponItems = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/getUsableCouponItems", params);
};
// 合并支付品牌商，获取商品使用优惠券信息
OrderService.prototype.combineGetUsableCouponItems = function (params) {
    var that = this;
    params.type = 'POST';
    params.contentType = params.contentType || 'application/json';
    that._serviceAjaxCom("/publics/tgouOrder/combineOrder/getUsableCouponItems", params);
};

OrderService.prototype.queryDeliveryList = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/queryDeliveryList", params);
};
/**
 * 购物车列表
 * @param params
 */
// OrderService.prototype.cartList = function (params) {
//     var that = this;
//     params.type = 'POST';
//     that._serviceAjaxCom("/publics/shopCart/cartList", params);
// };
// 购物车新接口，品牌商合并付款时为兼容老版本统一更换
OrderService.prototype.cartList = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/list", params);
};
/**
 * 删除购物车数据
 * @param params
 */
OrderService.prototype.delete = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/delete", params);
};
/**
 * 更新数量
 * @param params
 */
OrderService.prototype.updateQty = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/updateQty", params);
};
// OrderService.prototype.getActivity = function (params) {
//     var that = this;
//     params.type = 'POST';
//     that._serviceAjaxCom("/publics/shopCart/getActivity", params);
// };
// 获取优惠活动更换接口，为合并付款适配老版本
OrderService.prototype.getActivity = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/combine/order/getActivity", params);
};
OrderService.prototype.end = function (params) {
    var that = this;
    that._serviceAjaxCom("/publics/tgouOrder/end", params);
};

OrderService.prototype.buyAgain = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/buyAgain", params);
};

OrderService.prototype.giftProductStock = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/giftProductStock", params);
};



//取消售后
// 2020-11-17 废弃
OrderService.prototype.cancelReturn = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/returnRequest/cancelReturn", params);
};

//退货进程
OrderService.prototype.returnRequestLogs = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/returnRequest/returnRequestLogs", params);
};
OrderService.prototype.detail = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/detail", params);
};
OrderService.prototype.addShopCartList = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/shopCart/addList", params);
};
//获取礼品卡详细信息
OrderService.prototype.giftcardDetail = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/giftcard/detail", params);
};

OrderService.prototype.verifyGiveCoupon = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/verifyGiveCoupon", params);
};

//退货之前获取订单商品
OrderService.prototype.preApplyReturn = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/preApplyReturn", params);
};

//获取订单福利
OrderService.prototype.getBenefit = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/allBenefit", params);
};
//获取订单福利 含全部福利和未领取福利
OrderService.prototype.getALLBenefit = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/getAllBenefit", params);
};

OrderService.prototype.detail = function(params){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/detail", params);
};

OrderService.prototype._serviceAjaxCom = function (url, params) {
    params.url = this.domain + url;
    request(params);
};
/**
 * 获取前 20 个最新支付订单中的商品
 * @param   {Object}    params
 * @param   {Function}  params.success}
 * */
OrderService.prototype.getTopOrderInfo = function (params) {
    this._serviceAjaxCom('/publics/tgouOrder/getTopOrderInfo', params);
};
//获取扫码购购物车列表
OrderService.prototype.getShopcartList = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/scshop/shopcart/list", params);
};
//扫码购购物车添加商品
OrderService.prototype.shopcartAdd = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/scshop/shopcart/add", params);
};
//扫码购购物车减少商品数量
OrderService.prototype.shopcartReduce = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/scshop/shopcart/reduce", params);
};
//删除扫码购购物车列表商品
OrderService.prototype.shopcartDelete = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/scshop/shopcart/delete", params);
};
//扫码购添加购物袋
OrderService.prototype.addShoppingBag = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/scshop/shopcart/addShoppingBag", params);
};
//查该超市扫码购相关信息
OrderService.prototype.queryMarketShopping = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/store/queryMarketShopping", params);
};
//支付结果页推券
OrderService.prototype.tgGiftCoupon = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/tgGiftCoupon", params);
};
//茅台资格
OrderService.prototype.canBuyLimit = function (params) {
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/publics/tgouOrder/maotai/canBuyLimit", params);
};
/**
 * 获取保税商品的税率
 * @param   {Object}    params
 * @param   {Object}    params.data
 * @param   {Object}    params.data.products
 * @param   {number|string} params.data.storeId
 * @param   {boolean}   params.data.bonded
 * @param   {boolean}   params.data.complex
 * */
OrderService.prototype.productTax = function (params) {
    params.type = 'POST';
    this._serviceAjaxCom('/publics/tgouOrder/webProductTax', params);
};

OrderService.prototype.validateCode = function (params) {
    params.type = 'POST';
    this._serviceAjaxCom('/publics/tgouOrder/validate/code', params);
};
OrderService.prototype.needValidateCode = function (params) {
    params.type = 'POST';
    this._serviceAjaxCom('/publics/tgouOrder/validate/code/need', params);
};
// 判断是否新人
OrderService.prototype.isNewer = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/publics/tgouOrder/newMember', params);
};
// 获取订单归档年份信息
OrderService.prototype.getListYear = function (params) {
    params.type = 'GET';
    this._serviceAjaxCom('/publics/tgouOrder/archive/config/list', params);
};
// 收银台普通订单支付
OrderService.prototype.orderPay = function (params) {
    params.type = 'POST';
    this._serviceAjaxCom('/publics/tgouOrder/pay', params);
};
// 收银台获取到店自提核销码
OrderService.prototype.getPayCode = function (params) {
    params.type = 'POST';
    this._serviceAjaxCom('/publics/tgouOrder/getPayCode', params);
};
// 收银台获取订单信息
OrderService.prototype.prePayOrderInfo = function (params) {
    params.type = 'POST';
    this._serviceAjaxCom('/publics/tgouOrder/prePayOrderInfo', params);
};
// 聚合跨店券
OrderService.prototype.couponGroup = function (params) {
    params.type = 'POST';
    params.contentType = params.contentType || 'application/json';
    this._serviceAjaxCom('/publics/tgouOrder/coupon/group', params);
};
export default new OrderService();
